export const ROOT_URL = '/'
export const PROJECTS_URL = '/projects'
export const CONTACT_URL = '/contact'
export const ABOUT_ME_URL = '/about-me'
export const SERVICES_URL = '/services'
export const TESTIMONIALS_URL = "/testimonials"
export const FACEBOOK_URL = 'https://www.facebook.com/www.hypnotherapyireland.ie/'
export const YOUTUBE_URL = 'https://youtube.com/@marianfarrell3850?si=lbkSsNuva-NMZ08i'